<template>
    <select2 :value="value"
             @input="$emit('input', $event)"
             :plugin-options="courseGroupsSelect2Options"
             :dropdown-parent-selector="dropdownParentSelector"
             :options="courseGroupsOptions"
             :additional-fields="['isHidden', 'name']"
             :disabled="disabled"
             class="form-control">
    </select2>
</template>

<script>
    import select2Utils from "./select2Utils";

    const SearchGroupsComponent = {
        props: {
            dropdownParentSelector: {
                type: String
            },

            value: {
            },

            allowClear: {
                type: Boolean
            },

            disabled: {
                type: Boolean
            }
        },

        data() {
            const options = {
                width: "100%",
                placeholder: this.$t("enrollments.group"),
                matcher: select2Utils.allWordsMatcher
            };

            if (this.allowClear) {
                options.allowClear = true;
            }

            return {
                courseGroupsSelect2Options: options
            };
        },

        computed: {
            courseGroupsOptions() {
                const allGroups = this.$store.state.courseGroups;
                const hiddenGroups = allGroups.filter(cg => cg.isHidden);
                const notHiddenGroups = allGroups.filter(cg => !cg.isHidden);

                const options = notHiddenGroups.concat(hiddenGroups).map(cg => ({
                    id: cg.id,
                    text: cg.getDisplayName(),
                    name: cg.getDisplayName(),
                    isHidden: cg.isHidden
                }));

                return this.allowClear ? [{ id: "", text: "" }].concat(options) : options;
            }
        }
    };

    export default SearchGroupsComponent;
</script>